// Live data client. All callers must handle `error` + `stale` flags.
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const liveAPI = {
  history: (symbol, range) => axios.get(`${API}/indices/history`, { params: { symbol, range } }).then((r) => r.data),
  stats:   (symbol) => axios.get(`${API}/indices/stats`, { params: { symbol } }).then((r) => r.data),
  marketStatus: () => axios.get(`${API}/market-status`).then((r) => r.data),
  indices:      () => axios.get(`${API}/indices`).then((r) => r.data),
  marketStrip:  () => axios.get(`${API}/market-strip`).then((r) => r.data),
  news:         (category, opts = {}) => axios.get(`${API}/news`, {
    params: { ...(category ? { category } : {}), ...opts },
  }).then((r) => r.data),
  analyses:     (params = {}) => axios.get(`${API}/news/analyses`, { params }).then((r) => r.data),
  search:       (q) => axios.get(`${API}/search`, { params: { q } }).then((r) => r.data),
  morningBrief: () => axios.get(`${API}/morning-brief`, { timeout: 90_000 }).then((r) => r.data),
  morningBriefForce: () => axios.post(`${API}/morning-brief`, {}, { timeout: 90_000 }).then((r) => r.data),
  marketNarrative: () => axios.get(`${API}/market-narrative`, { timeout: 90_000 }).then((r) => r.data),
  eventDetails: (key) => axios.get(`${API}/events/${key}`, { timeout: 20_000 }).then((r) => r.data),
  analyzeNews:  (headline, summary) => axios.post(`${API}/news/analyze`, { headline, summary }).then((r) => r.data),
};
